import { apiClient } from '@app/api';
import { parseRangeFromTs, toTimestamp } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';
import { useFocus } from '../../../stores/stream-screen.store';
import LowerthirdView from './LowerthirdView';
import { Station } from '@app/core/types/stations';

interface ILowerthirdContainer {
  station: Station;
}

const LowerthirdContainer: React.FunctionComponent<ILowerthirdContainer> = (props) => {
  const { station } = props;
  const focus = useFocus();
  const [debouncedFocus] = useDebounce(focus, 300);
  const range = parseRangeFromTs(debouncedFocus);
  const { data, isLoading } = useQuery({
    queryKey: ['lowerthird', station.slug, range.from, range.to],

    queryFn: () =>
      apiClient.audit
        .fetchLowerthirdRange(station.slug, {
          from: toTimestamp(range.from),
          to: toTimestamp(range.to),
        })
        .then((res) => res),
  });

  return <LowerthirdView data={data ?? []} loading={isLoading} station={station} />;
};

export default LowerthirdContainer;
